/**
 * Betriebsurlaub-Hinweis (zeitgesteuert)
 * ----------------------------------------
 * WICHTIG: Diese Datei ist die EINZIGE Quelle für den Betriebsurlaub-
 * Zeitraum. Sie wird unverändert sowohl im Theme (Browser, für den
 * Hinweis-Banner in den Konfiguratoren) als auch im Backend (PHP, für den
 * Hinweis auf der Versandkosten-Zeile/Bestellnotiz) eingesetzt. Nach einer
 * Änderung an dieser Datei IMMER auch
 * backend-php/private/lib/company-notice.php von Hand nachziehen (siehe
 * Kommentar dort) – scripts/sync-calculators.js kopiert nur die JS-Variante
 * nach theme/assets/ bzw. backend/.
 *
 * Kundenvorgabe (Stand 14.08.2026): Betriebsurlaub vom 15.08. bis 30.08.2026
 * (jeweils inklusive), Bestellungen werden ab dem 31.08.2026 wieder
 * bearbeitet. Der Hinweis soll automatisch ab dem 31.08. wieder
 * verschwinden – dafür genügt es, dass "heute" außerhalb des unten
 * definierten Zeitraums liegt, es ist KEINE manuelle Deaktivierung nötig.
 *
 * FÜR KÜNFTIGE URLAUBSZEITRÄUME: Einfach BETRIEBSURLAUB_START/_END/
 * RESUME_DATE_LABEL unten anpassen (und in company-notice.php identisch
 * nachziehen) – der Rest (Banner, Versandtitel, Bestellnotiz) berechnet sich
 * überall automatisch neu.
 *
 * ACHTUNG – ein offener Punkt: Der Frontend-Banner (diese Datei, im Browser)
 * nutzt die lokale Systemzeit des Kunden-Browsers, der PHP-Mirror
 * (company-notice.php, maßgeblich für Versandtitel/Bestellung) nutzt die
 * Serverzeit in der Zeitzone Europe/Berlin. In den allermeisten Fällen sind
 * beide identisch – nur bei Kunden mit stark abweichender Browser-Zeitzone
 * könnte der Banner exakt am Start-/Endtag um max. ±1 Tag abweichen. Für
 * einen reinen Informations-Hinweis (nicht preisrelevant) unkritisch.
 */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) {
    module.exports = factory();
  } else {
    root.CompanyNotice = factory();
  }
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  // Zeitraum (inklusive Start- und Endtag), siehe Datei-Kopf.
  var BETRIEBSURLAUB_START = '2026-08-15';
  var BETRIEBSURLAUB_END = '2026-08-30';
  var RESUME_DATE_LABEL = '31.08.2026';

  // Lokales Datum (Kalendertag, ohne Uhrzeit) als "YYYY-MM-DD", damit der
  // Vergleich tagesgenau und unabhängig von der Uhrzeit funktioniert.
  function todayIsoDate() {
    var d = new Date();
    var y = d.getFullYear();
    var m = String(d.getMonth() + 1);
    if (m.length < 2) m = '0' + m;
    var day = String(d.getDate());
    if (day.length < 2) day = '0' + day;
    return y + '-' + m + '-' + day;
  }

  function isBetriebsurlaub() {
    var today = todayIsoDate();
    return today >= BETRIEBSURLAUB_START && today <= BETRIEBSURLAUB_END;
  }

  var NOTICE_TEXT = 'Hinweis: Erfurt Etuis befindet sich vom 15.08. bis 30.08.2026 im Betriebsurlaub. Bestellungen werden ab dem ' + RESUME_DATE_LABEL + ' wieder bearbeitet.';

  // Kurzfassung für die Versandkosten-Zeile im Checkout (dort ist wenig
  // Platz, daher kompakter formuliert als NOTICE_TEXT).
  var SHIPPING_SUFFIX = ' (Betriebsurlaub bis 30.08. – Bearbeitung ab ' + RESUME_DATE_LABEL + ')';

  return {
    isBetriebsurlaub: isBetriebsurlaub,
    NOTICE_TEXT: NOTICE_TEXT,
    SHIPPING_SUFFIX: SHIPPING_SUFFIX,
    RESUME_DATE_LABEL: RESUME_DATE_LABEL,
    BETRIEBSURLAUB_START: BETRIEBSURLAUB_START,
    BETRIEBSURLAUB_END: BETRIEBSURLAUB_END
  };
});
